"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class HttpUtil {
    static getFileNameFromHeaders(headers) {
        const contentType = headers.get('Content-Type');
        if (contentType === null) {
            throw new Error('Missing fileName, please use ContentFileResponse in your controller and set a filename');
        }
        return contentType.slice(contentType.indexOf('name="') + 6, -1);
    }
    static handleDownloadResponse(response) {
        return response.blob().then((data) => {
            const fileName = HttpUtil.getFileNameFromHeaders(response.headers);
            const anchorElement = document.createElement('a');
            const objectURL = window.URL.createObjectURL(data);
            anchorElement.href = objectURL;
            anchorElement.download = fileName;
            document.body.append(anchorElement);
            anchorElement.click();
            anchorElement.remove();
            window.URL.revokeObjectURL(objectURL);
        });
    }
}
exports.default = HttpUtil;
//# sourceMappingURL=HttpUtil.js.map